/// <amd-module name="Wiki/Search/SearchResult" />
import React = require("react");
import { ISearchResult, ISearchStatus } from "VSS/Platform/Search";

export interface IWikiSearchResultProps {
    searchStatus?: ISearchStatus;
}

export class WikiSearchResultComponent extends React.Component<IWikiSearchResultProps, {}> {
    public render(): JSX.Element {
        return <div>Wiki Search Results Placeholder</div>;
    }

    public componentDidMount(): void {
        this.props.searchStatus && this.props.searchStatus.searchResult.subscribe(this.onSearchResultSet);
    }

    public componentWillReceiveProps(newProps: IWikiSearchResultProps): void {
        this.props.searchStatus && this.props.searchStatus.searchResult.unsubscribe(this.onSearchResultSet);
        newProps.searchStatus && newProps.searchStatus.searchResult.subscribe(this.onSearchResultSet);
    }

    public componentWillUnmount(): void {
        this.props.searchStatus && this.props.searchStatus.searchResult.unsubscribe(this.onSearchResultSet);
    }

    private onSearchResultSet = (searchResult: ISearchResult): void => {
        this.forceUpdate();
    };
}
